import { OfferKindEnum } from '../../services/exports/Constants';

export const OFFERS_WITH_PRODUCTS: Readonly<OfferKindEnum[]> = [
  OfferKindEnum.AmountOffByProducts,
  OfferKindEnum.PercentageOffByProducts,
  OfferKindEnum.FreeItemByProducts,
  OfferKindEnum.FreeItemByMinSpendValue,
  OfferKindEnum.Bogo,
  OfferKindEnum.BogoHalfPrice,
];

export const OFFERS_PRODUCTS_KEYS_BY_KIND: Readonly<Partial<Record<OfferKindEnum, string[]>>> = {
  [OfferKindEnum.AmountOffByProducts]: ['products'],
  [OfferKindEnum.PercentageOffByProducts]: ['products'],
  [OfferKindEnum.Bogo]: ['products'],
  [OfferKindEnum.BogoHalfPrice]: ['products'],
  [OfferKindEnum.FreeItemByProducts]: ['products', 'free_products'],
  [OfferKindEnum.FreeItemByMinSpendValue]: ['free_products'],
};

// Product-targeted kinds. Adding the item is itself what unlocks these, so they are always
// previewable. The Bogo kinds are included for the product modal, where the quantity is real: their
// handlers already refuse to discount below quantity 2, so a single-unit menu card is left at full
// price without needing a special case here.
export const PREVIEWABLE_OFFER_KINDS: Readonly<OfferKindEnum[]> = [
  OfferKindEnum.PercentageOffByProducts,
  OfferKindEnum.AmountOffByProducts,
  OfferKindEnum.FreeItemByProducts,
  OfferKindEnum.Bogo,
  OfferKindEnum.BogoHalfPrice,
];

// Min-spend kinds may only be previewed once the basket already meets the threshold, i.e. while
// the offer sits in `unlockedOffers`. This mirrors the badge policy in ProductItem's OfferBadge.
// `AmountOffByMinSpendValue` is deliberately absent: its handler has no `apply` (it discounts the
// order, not a line) and it has no menu handler either, so it neither badges nor prices.
export const UNLOCKED_ONLY_PREVIEWABLE_OFFER_KINDS: Readonly<OfferKindEnum[]> = [
  OfferKindEnum.PercentageOffByMinSpendValue,
  OfferKindEnum.FreeItemByMinSpendValue,
];

// Kinds whose `apply` carries no product filter, so every line — and therefore every card — is
// discounted once they are previewable.
export const ALL_PRODUCTS_PREVIEWABLE_OFFER_KINDS: Readonly<OfferKindEnum[]> = [
  OfferKindEnum.PercentageOffByMinSpendValue,
];

// Which `details` keys hold the products whose PRICE changes at quantity 1. Drives the menu-card
// pre-filter, so it differs from OFFERS_PRODUCTS_KEYS_BY_KIND twice over:
//  - FreeItemByProducts lists only `free_products`; `products` are triggers and stay at full price.
//  - The Bogo kinds are absent entirely, because they discount nothing at quantity 1.
export const OFFERS_DISCOUNTED_PRODUCTS_KEYS_BY_KIND: Readonly<Partial<Record<OfferKindEnum, string[]>>> = {
  [OfferKindEnum.AmountOffByProducts]: ['products'],
  [OfferKindEnum.PercentageOffByProducts]: ['products'],
  [OfferKindEnum.FreeItemByProducts]: ['free_products'],
  [OfferKindEnum.FreeItemByMinSpendValue]: ['free_products'],
};
